export default
class ContentError extends ReferenceError {
  constructor(msg, contentId, contentType = 'article') {
    super(msg)
    this.name = `ContentError: ${contentType}:${contentId}`
    this.contentId = contentId
    this.tempalteType = contentType
  }
}
